import config from '../../config';

export default {
  url: `${config.api.baseURL}/accounts`,
  transformer(data) {
    return data;
  }
};



// WEBPACK FOOTER //
// ./src/api/accounts/list.js